import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchDocumentos } from '../../peticiones_API/PeticionesDocumentos';
import { fetchGetPerfil } from '../../peticiones_API/PeticionesAuth';
import Titulo from "../elementos/basicos/Titulo";
import TablaDocumentos from './TablaDocumentos';
import CarruselCategorias from './CarruselCategorias';
import ListaEmpresas from './ListaEmpresas';
import ListaDepartamentos from './ListaDepartamentos';
import styled from 'styled-components';
import { UsuarioContext } from "../providers/personaContext";
import {
    Box,
    Paper,
    TextField,
    CircularProgress,
    Button,
    Breadcrumbs,
    Link,
    Typography
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';

const VisorListaDocumentos = () => {
    const { persona } = useContext(UsuarioContext);
    const location = useLocation();
    const navigate = useNavigate();
    const urlPadre = window.location.pathname;

    let params = new URLSearchParams(location.search);
    const tipoFromUrl = params.get("tipo") || null;
    const idFromUrl = params.get("id") || null;
    const empresaIdFromUrl = params.get("empresaId") || null;

    const [loading, setLoading] = useState(true);

    const [vistaActual, setVistaActual] = useState(tipoFromUrl);
    const [idSeleccionado, setIdSeleccionado] = useState(idFromUrl);
    const [empresaIdContexto, setEmpresaIdContexto] = useState(empresaIdFromUrl);

    const [departamentos, setDepartamentos] = useState([]);
    const [empresas, setEmpresas] = useState([]);

    const [todosLosDocumentos, setTodosLosDocumentos] = useState([]);
    const [conteoUsuario, setConteoUsuario] = useState(0);
    const [conteoGeneral, setConteoGeneral] = useState(0);
    const [conteoEmpresas, setConteoEmpresas] = useState({});
    const [conteoDepartamentos, setConteoDepartamentos] = useState({});
    const [empresasConDocs, setEmpresasConDocs] = useState([]);
    const [departamentosConDocs, setDepartamentosConDocs] = useState([]);

    const [documentosFiltrados, setDocumentosFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [ordenColumna, setOrdenColumna] = useState('');
    const [orden, setOrden] = useState('');
    const [nombreSeleccionado, setNombreSeleccionado] = useState('');

    useEffect(() => {
        async function cargarDatosIniciales() {
            try {
                if (!persona || !persona.rol) {
                    setLoading(false);
                    return;
                }

                setLoading(true);

                const [perfilResponse, documentosResponse] = await Promise.all([
                    fetchGetPerfil(),
                    fetchDocumentos(1, 10000, null, null, null) // Check cuando se quiera paginar (o hacerlo en local ;) )!
                ]);

                const perfilData = perfilResponse.data;
                const todosLosDocs = documentosResponse.data || [];


                const empresasMap = new Map();
                const departamentosMap = new Map();

                perfilData.Cargos?.forEach(cargo => {
                    if (cargo.Negocio && !empresasMap.has(cargo.Negocio.Id)) {
                        empresasMap.set(cargo.Negocio.Id, {
                            Id: cargo.Negocio.Id,
                            nombre: cargo.Negocio.nombre,
                            logo: cargo.Negocio.logo
                        });
                    }

                    if (cargo.Departamento && !departamentosMap.has(cargo.Departamento.Id)) {
                        departamentosMap.set(cargo.Departamento.Id, {
                            Id: cargo.Departamento.Id,
                            nombre: cargo.Departamento.nombre,
                            tipo: cargo.Departamento.tipo
                        });
                    }
                });

                const empresasDelPerfil = Array.from(empresasMap.values());
                const departamentosDelPerfil = Array.from(departamentosMap.values());
                
                const depsInternos = departamentosDelPerfil.filter(dep => dep.tipo === "interno");

                setDepartamentos(depsInternos);
                setEmpresas(empresasDelPerfil);
                setTodosLosDocumentos(todosLosDocs);

                calcularConteos(todosLosDocs, empresasDelPerfil, depsInternos);

                setLoading(false);
            } catch (error) {
                console.error("Error al cargar datos iniciales:", error);
                setLoading(false);
            }
        }

        cargarDatosIniciales();
    }, [persona]);

    const calcularConteos = (docs, listaEmpresas, listaDepartamentos) => {
        const docsUsuario = docs.filter(doc =>
            doc.permisos && doc.permisos.some(permiso => permiso.tipo_id === 'usuario')
        );
        setConteoUsuario(docsUsuario.length);

        const docsGenerales = docs.filter(doc =>
            doc.permisos && doc.permisos.some(permiso => permiso.tipo_id === 'general')
        );
        setConteoGeneral(docsGenerales.length);

        const empresasMap = {};
        listaEmpresas.forEach(emp => {
            empresasMap[emp.Id] = 0;
        });

        docs.forEach(doc => {
            doc.permisos?.forEach(permiso => {
                if (permiso.tipo_id === 'empresa' && permiso.permitido_id && empresasMap.hasOwnProperty(permiso.permitido_id)) {
                    empresasMap[permiso.permitido_id] = (empresasMap[permiso.permitido_id] || 0) + 1;
                }
            });
        });
        setConteoEmpresas(empresasMap);
        
        setEmpresasConDocs(listaEmpresas);

        const departamentosMap = {};
        const departamentosEmpresaMap = {};
        
        listaDepartamentos.forEach(dep => {
            departamentosMap[dep.Id] = 0;
            departamentosEmpresaMap[dep.Id] = new Set();
        });

        docs.forEach(doc => {
            doc.permisos?.forEach(permiso => {
                if (permiso.tipo_id === 'departamento' && permiso.permitido_id && departamentosMap.hasOwnProperty(permiso.permitido_id)) {
                    departamentosMap[permiso.permitido_id] = (departamentosMap[permiso.permitido_id] || 0) + 1;

                    if (permiso.empresa_id) {
                        departamentosEmpresaMap[permiso.permitido_id].add(permiso.empresa_id);
                    } else {
                        departamentosEmpresaMap[permiso.permitido_id].add(null);
                    }
                }
            });
        });

        setConteoDepartamentos(departamentosMap);

        const depsConDocs = listaDepartamentos.map(dep => ({
            ...dep,
            empresasEnPermisos: Array.from(departamentosEmpresaMap[dep.Id] || [])
        }));
        setDepartamentosConDocs(depsConDocs);
    };

    useEffect(() => {
        if (!vistaActual || !['usuario', 'general', 'empresa', 'departamento'].includes(vistaActual) || todosLosDocumentos.length === 0) {
            return;
        }

        let docsFiltrados = [...todosLosDocumentos];

        if (vistaActual === 'usuario') {
            docsFiltrados = docsFiltrados.filter(doc =>
                doc.permisos && doc.permisos.some(permiso => permiso.tipo_id === 'usuario')
            );
            setNombreSeleccionado('');
        } else if (vistaActual === 'general') {
            docsFiltrados = docsFiltrados.filter(doc =>
                doc.permisos && doc.permisos.some(permiso => permiso.tipo_id === 'general')
            );
            setNombreSeleccionado('General');
        } else if (vistaActual === 'empresa' && idSeleccionado) {
            docsFiltrados = docsFiltrados.filter(doc =>
                doc.permisos && doc.permisos.some(permiso =>
                    permiso.tipo_id === 'empresa' && permiso.permitido_id === parseInt(idSeleccionado)
                )
            );
            const empresa = empresas.find(emp => emp.Id === parseInt(idSeleccionado));
            setNombreSeleccionado(empresa?.nombre || 'Empresa');
        } else if (vistaActual === 'departamento' && idSeleccionado) {
            docsFiltrados = docsFiltrados.filter(doc =>
                doc.permisos && doc.permisos.some(permiso =>
                    permiso.tipo_id === 'departamento' && permiso.permitido_id === parseInt(idSeleccionado)
                )
            );
            const departamento = departamentos.find(dep => dep.Id === parseInt(idSeleccionado));
            setNombreSeleccionado(departamento?.nombre || 'Departamento');
        }

        if (busqueda) {
            const busquedaLower = busqueda.toLowerCase();
            docsFiltrados = docsFiltrados.filter(doc => {
                const nombreArchivo = doc.ruta.split('/').pop().toLowerCase();
                const creador = `${doc.creador.nombre} ${doc.creador.apellidos}`.toLowerCase();
                const editor = `${doc.editor.nombre} ${doc.editor.apellidos}`.toLowerCase();
                return nombreArchivo.includes(busquedaLower) ||
                    creador.includes(busquedaLower) ||
                    editor.includes(busquedaLower);
            });
        }

        if (ordenColumna) {
            docsFiltrados.sort((a, b) => {
                let valorA, valorB;

                switch (ordenColumna) {
                    case 'ruta':
                        valorA = a.ruta.split('/').pop().toLowerCase();
                        valorB = b.ruta.split('/').pop().toLowerCase();
                        break;
                    case 'creador_nombre':
                        valorA = `${a.creador.nombre} ${a.creador.apellidos}`.toLowerCase();
                        valorB = `${b.creador.nombre} ${b.creador.apellidos}`.toLowerCase();
                        break;
                    case 'editor_nombre':
                        valorA = `${a.editor.nombre} ${a.editor.apellidos}`.toLowerCase();
                        valorB = `${b.editor.nombre} ${b.editor.apellidos}`.toLowerCase();
                        break;
                    case 'tamaño':
                        valorA = a.tamaño;
                        valorB = b.tamaño;
                        break;
                    case 'createdAt':
                        valorA = new Date(a.createdAt).getTime();
                        valorB = new Date(b.createdAt).getTime();
                        break;
                    case 'updatedAt':
                        valorA = new Date(a.updatedAt).getTime();
                        valorB = new Date(b.updatedAt).getTime();
                        break;
                    default:
                        return 0;
                }

                if (valorA < valorB) return orden === 'ASC' ? -1 : 1;
                if (valorA > valorB) return orden === 'ASC' ? 1 : -1;
                return 0;
            });
        }

        setDocumentosFiltrados(docsFiltrados);
    }, [vistaActual, idSeleccionado, busqueda, ordenColumna, orden, todosLosDocumentos, empresas, departamentos]);

    useEffect(() => {
        setVistaActual(tipoFromUrl);
        setIdSeleccionado(idFromUrl);
        setEmpresaIdContexto(empresaIdFromUrl);
    }, [tipoFromUrl, idFromUrl, empresaIdFromUrl]);

    const handleOrdenar = (columna) => {
        if (ordenColumna === columna) {
            setOrden(orden === 'ASC' ? 'DESC' : 'ASC');
        } else {
            setOrdenColumna(columna);
            setOrden('ASC');
        }
    };

    const volverAlCarrusel = () => {
        setVistaActual(null);
        setIdSeleccionado(null);
        setEmpresaIdContexto(null);
        setBusqueda('');
        setOrdenColumna('');
        setOrden('');
        navigate(urlPadre);
    };

    const navegarAListaEmpresas = () => {
        const params = new URLSearchParams();
        params.set('tipo', 'listaEmpresas');
        navigate(`?${params.toString()}`);
    };

    const navegarAListaDepartamentos = (empresaId = null) => {
        const params = new URLSearchParams();
        params.set('tipo', 'listaDepartamentos');
        if (empresaId) {
            params.set('empresaId', empresaId);
        }
        navigate(`?${params.toString()}`);
    };

    const renderBreadcrumbs = () => {
        const breadcrumbItems = [];

        breadcrumbItems.push(
            <Link
                key="inicio"
                underline="hover"
                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                color="inherit"
                onClick={volverAlCarrusel}
            >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
                Inicio
            </Link>
        );

        if (vistaActual === 'listaEmpresas') {
            breadcrumbItems.push(
                <Typography key="empresas" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                    <BusinessIcon sx={{ mr: 0.5 }} fontSize="small" />
                    Negocios
                </Typography>
            );
        } else if (vistaActual === 'listaDepartamentos') {
            if (empresaIdContexto) {
                const empresa = empresas.find(emp => emp.Id === parseInt(empresaIdContexto));
                breadcrumbItems.push(
                    <Link
                        key="empresas-lista"
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        color="inherit"
                        onClick={navegarAListaEmpresas}
                    >
                        <BusinessIcon sx={{ mr: 0.5 }} fontSize="small" />
                        Negocios
                    </Link>
                );
                breadcrumbItems.push(
                    <Link
                        key="empresa-actual"
                        underline="hover"
                        sx={{ cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            const params = new URLSearchParams();
                            params.set('tipo', 'empresa');
                            params.set('id', empresaIdContexto);
                            navigate(`?${params.toString()}`);
                        }}
                    >
                        {empresa?.nombre || 'Empresa'}
                    </Link>
                );
            }
            breadcrumbItems.push(
                <Typography key="departamentos" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                    <GroupsIcon sx={{ mr: 0.5 }} fontSize="small" />
                    Departamentos
                </Typography>
            );
        } else if (vistaActual === 'empresa') {
            breadcrumbItems.push(
                <Link
                    key="empresas-lista"
                    underline="hover"
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    color="inherit"
                    onClick={navegarAListaEmpresas}
                >
                    <BusinessIcon sx={{ mr: 0.5 }} fontSize="small" />
                    Negocios
                </Link>
            );
            breadcrumbItems.push(
                <Typography key="empresa-actual" color="text.primary">
                    {nombreSeleccionado}
                </Typography>
            );
        } else if (vistaActual === 'departamento') {
            let empresaDelDepartamento = null;
            if (!empresaIdContexto) {
                const docsDelDepartamento = todosLosDocumentos.filter(doc =>
                    doc.permisos && doc.permisos.some(permiso =>
                        permiso.tipo_id === 'departamento' && permiso.permitido_id === parseInt(idSeleccionado)
                    )
                );

                for (const doc of docsDelDepartamento) {
                    const permisoDep = doc.permisos.find(p =>
                        p.tipo_id === 'departamento' && p.permitido_id === parseInt(idSeleccionado)
                    );
                    if (permisoDep && permisoDep.empresa_id) {
                        empresaDelDepartamento = permisoDep.empresa_id;
                        break;
                    }
                }
            }

            const empresaId = empresaIdContexto || empresaDelDepartamento;

            if (empresaId) {
                const empresa = empresas.find(emp => emp.Id === parseInt(empresaId));

                breadcrumbItems.push(
                    <Link
                        key="empresas-lista"
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        color="inherit"
                        onClick={navegarAListaEmpresas}
                    >
                        <BusinessIcon sx={{ mr: 0.5 }} fontSize="small" />
                        Negocios
                    </Link>
                );
                breadcrumbItems.push(
                    <Link
                        key="empresa-actual"
                        underline="hover"
                        sx={{ cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            const params = new URLSearchParams();
                            params.set('tipo', 'empresa');
                            params.set('id', empresaId);
                            navigate(`?${params.toString()}`);
                        }}
                    >
                        {empresa?.nombre || 'Empresa'}
                    </Link>
                );
                breadcrumbItems.push(
                    <Link
                        key="departamentos-lista"
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => navegarAListaDepartamentos(empresaId)}
                    >
                        <GroupsIcon sx={{ mr: 0.5 }} fontSize="small" />
                        Departamentos
                    </Link>
                );
            } else {
                breadcrumbItems.push(
                    <Link
                        key="departamentos-lista"
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => navegarAListaDepartamentos()}
                    >
                        <GroupsIcon sx={{ mr: 0.5 }} fontSize="small" />
                        Departamentos
                    </Link>
                );
            }

            breadcrumbItems.push(
                <Typography key="departamento-actual" color="text.primary">
                    {nombreSeleccionado}
                </Typography>
            );
        } else if (vistaActual === 'usuario') {
            breadcrumbItems.push(
                <Typography key="usuario" color="text.primary">
                    Mis Documentos
                </Typography>
            );
        } else if (vistaActual === 'general') {
            breadcrumbItems.push(
                <Typography key="general" color="text.primary">
                    General
                </Typography>
            );
        }

        return <Breadcrumbs aria-label="breadcrumb">{breadcrumbItems}</Breadcrumbs>;
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <CabeceraForm>
                <Titulo
                    texto="DOCUMENTOS"
                    tituloTabla="true"
                />
            </CabeceraForm>

            <ContainerPrincipal>
                
                {/* Vista de Carrusel - Home */}
                {vistaActual === null && (
                    <CarruselCategorias
                        empresas={empresasConDocs}
                        departamentos={departamentosConDocs}
                        todosLosNegocios={empresas}
                        documentosUsuario={conteoUsuario}
                        documentosGenerales={conteoGeneral}
                        documentosNegocios={conteoEmpresas}
                        documentosDepartamentos={conteoDepartamentos}
                    />
                )}

                {/* Vista Lista de Empresas */}
                {vistaActual === 'listaEmpresas' && (
                    <Paper elevation={3} sx={{ width: '100%', p: 3 }}>
                        <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
                            {renderBreadcrumbs()}
                            <Button
                                variant="outlined"
                                startIcon={<ArrowBackIcon />}
                                onClick={volverAlCarrusel}
                            >
                                Volver
                            </Button>
                        </Box>
                        <ListaEmpresas
                            negocios={empresasConDocs}
                            documentosNegocios={conteoEmpresas}
                        />
                    </Paper>
                )}

                {/* Vista Lista de Departamentos */}
                {vistaActual === 'listaDepartamentos' && (
                    <Paper elevation={3} sx={{ width: '100%', p: 3 }}>
                        <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
                            {renderBreadcrumbs()}
                            <Button
                                variant="outlined"
                                startIcon={<ArrowBackIcon />}
                                onClick={() => {
                                    if (empresaIdContexto) {
                                        const params = new URLSearchParams();
                                        params.set('tipo', 'empresa');
                                        params.set('id', empresaIdContexto);
                                        navigate(`?${params.toString()}`);
                                    } else {
                                        volverAlCarrusel();
                                    }
                                }}
                            >
                                Volver
                            </Button>
                        </Box>
                        <ListaDepartamentos
                            departamentos={departamentosConDocs}
                            documentosDepartamentos={conteoDepartamentos}
                            empresaId={empresaIdContexto}
                            todosLosDocumentos={todosLosDocumentos}
                        />
                    </Paper>
                )}

                {/* Vista de Tabla - Usuario, General, Empresa o Departamento */}
                {['usuario', 'general', 'empresa', 'departamento'].includes(vistaActual) && (
                    <Paper elevation={3} sx={{ width: '100%', p: 3 }}>
                        <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
                            {renderBreadcrumbs()}
                            <Button
                                variant="outlined"
                                startIcon={<ArrowBackIcon />}
                                onClick={() => {
                                    if (vistaActual === 'empresa') {
                                        navegarAListaEmpresas();
                                    } else if (vistaActual === 'departamento') {
                                        navegarAListaDepartamentos(empresaIdContexto);
                                    } else if (vistaActual === 'general' || vistaActual === 'usuario') {
                                        volverAlCarrusel();
                                    } else {
                                        volverAlCarrusel();
                                    }
                                }}
                            >
                                Volver
                            </Button>
                        </Box>

                        <Box mb={3}>
                            <TextField
                                fullWidth
                                label="Buscar documento"
                                variant="outlined"
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                placeholder="Buscar por nombre de archivo, creador o editor..."
                            />
                        </Box>

                        {documentosFiltrados.length === 0 ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="200px"
                                bgcolor="#f5f5f5"
                                borderRadius={2}
                            >
                                <Typography variant="h6" color="textSecondary">
                                    No se encontraron documentos
                                </Typography>
                            </Box>
                        ) : (
                            <TablaDocumentos
                                documentos={documentosFiltrados}
                                meta={{
                                    total: documentosFiltrados.length,
                                    per_page: documentosFiltrados.length,
                                    current_page: 1,
                                    totalPages: 1
                                }}
                                onOrdenar={handleOrdenar}
                                ordenColumna={ordenColumna}
                                orden={orden}
                            />
                        )}
                    </Paper>
                )}
            </ContainerPrincipal>
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 0 0% 1% 0%;
    padding: 0 2%;
`;

const ContainerPrincipal = styled.div`
    padding: 0 2%;
    margin-bottom: 2%;
    display: flex;
    justify-content: center;
    width: 100%;
`;

export default VisorListaDocumentos;
